import { useIsAdmin } from '../auth';

/**
 * Componente que inyecta estilos para ocultar el botón "New announcement" cuando el usuario no es administrador.
 * Este enfoque no modifica la estructura del plugin original de anuncios, solo aplica estilos condicionales.
 */
export const HideNewAnnouncementButton = () => {
  const { isAdmin } = useIsAdmin();

  // Si el usuario es administrador, no inyectamos ningún estilo
  if (isAdmin) {
    return null;
  }

  // Si el usuario no es administrador, ocultamos el botón con CSS
  return (
    <style>
      {`
        /* Ocultar botón de nuevo anuncio para usuarios no administradores */
        button[data-testid="create-announcement-button"],
        a[data-testid="create-announcement-button"],
        button.backstage-plugin-announcements-create-button,
        a.backstage-plugin-announcements-create-button,
        .MuiBox-root-1491.MuiBox-root-1658.BackstageContentHeader-rightItemsBox-1653,
        .BackstageContentHeader-rightItemsBox-1653,
        div[class*="BackstageContentHeader-rightItemsBox"],
        a[href*="/announcements/admin/create"],
        .MuiButton-root a[href*="/announcements/admin/create"],
        .MuiButtonBase-root[href*="/announcements/admin/create"],
        .MuiLink-root[href*="/announcements/admin/create"] {
          display: none !important;
        }

        /* Deshabilitar enlaces a la creación de anuncios */
        a[href*="/announcements/admin/create"] {
          pointer-events: none !important;
          opacity: 0.5 !important;
          cursor: default !important;
        }
      `}
    </style>
  );
};
